// extracted by mini-css-extract-plugin
module.exports = {"title":"ProcessAutomationDashboard_title__38Nv2","tabSwitch":"ProcessAutomationDashboard_tabSwitch__1suDs"};